import { result } from 'lodash';
import { BaseModel } from '../../../vendor_core/core/src/model/BaseModel';
import SpinModel from '../../../vendor_core/core/src/model/SpinModel';
import { IOverlayData, OverlayType } from '../../../vendor_core/core/src/server/data/ISpinData';
import Utils from '../../../vendor_core/core/src/utils/Utils';
import { IBBData } from './IBBData';


class BBModel extends BaseModel<IBBData> {
    public cascades = []
    public cascadesOverlay = [];
    public spinStartTime = 0;
    public allowFakeScreenShakeTrigger = 0;
    public hasExplode = false;
    public changeWildFromReel: { reel: number, row: number }[] = [];
    public changeWildToReel: { reel: number, row: number }[] = [];
    public hasAnticipation = false;
    public stopIncrementAnticipationDelay = false;
    public anticipationDelayTime = 0.3;
    public anticipationIncrement = 0.7;
    public symbolTint = 16777215;
    public autoplayDelay: number = 0.2;

    public getOverlays(type: OverlayType): IOverlayData[] {
        let currentOverlays = this.cascadesOverlay;
        let overlays: IOverlayData[] = [];
        for (let overlayId in currentOverlays) {
            if (currentOverlays[overlayId].type === type) {
                overlays.push(Utils.deepClone(currentOverlays[overlayId]));
            }
        }
        return overlays;
    }

    public getAnticipationTimeDelay = () => {
        let result = this.anticipationDelayTime;
        if (!this.stopIncrementAnticipationDelay) {
            this.anticipationDelayTime += this.anticipationIncrement;
        }
        return result
    }

    public setChangeWildToReelData = (data: { reel: number, row: number }) => {
        this.changeWildToReel.push(data)
    }
    public setChangeWildFromReelData = (data: { reel: number, row: number }) => {
        this.changeWildFromReel.push(data)
    }
    public resetAnticipation = () => {
        this.hasAnticipation = false;
        this.anticipationDelayTime = 0.3;
        this.stopIncrementAnticipationDelay = false;
    }

    public resetFromToVerbsArrays = () => {
        this.changeWildFromReel = [];
        this.changeWildToReel = [];
    }

    public getMovedToReelWilds = (reelIndex: number): number[] => {
        let result = [];
        this.changeWildToReel.forEach(data => {
            if (data.reel === reelIndex) {
                result.push(data.row)
            }
        })

        return result
    }
    public getMovedFromReelWilds = (reelIndex: number): number[] => {
        let result = [];
        this.changeWildFromReel.forEach(data => {
            if (data.reel === reelIndex) {
                result.push(data.row)
            }
        })

        return result
    }

    public hasOverlay(type?: OverlayType): boolean {
        let currentOverlays = this.cascadesOverlay;
        let hasOverlays = Boolean(currentOverlays && currentOverlays.length);
        if (type && hasOverlays) {
            hasOverlays = false;
            currentOverlays.forEach((overlay) => {
                if (overlay.type === type) {
                    hasOverlays = true;
                }
            });
        }
        return hasOverlays;
    }

    public getCurrentSpinProperty(property) {
        if (
            this.cascades &&
            SpinModel.cascadeIndex != -1 &&
            this.cascades.length > 0 &&
            SpinModel.cascadeIndex < this.cascades.length
        ) {
            // If there are cascades to be shown - get the prop from there

            return this.cascades[SpinModel.cascadeIndex][property];
        } else {
            // If not - get it from the current spin model
            return this[property];
        }
    }
}

export default new BBModel();
